import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "hotel-list-item-features" }

import type { ItemType } from '@/interfaces/hotel-list-types/hotel-list-types';

import BaseIcon from '@lmt-rpb/BaseIcon/BaseIcon.vue';

type Props = {
	popularAttributes: ItemType['PopularAttributes'];
};

export default /*@__PURE__*/_defineComponent({
  __name: 'HotelListItemFeatures',
  props: {
    popularAttributes: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popularAttributes, (attribute) => {
      return (_openBlock(), _createElementBlock("li", {
        key: attribute,
        class: "hotel-list-item-features__list-item"
      }, [
        _createVNode(BaseIcon, {
          name: "check",
          class: "hotel-list-item-features__list-icon"
        }),
        _createTextVNode(" " + _toDisplayString(attribute), 1 /* TEXT */)
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})